import React from "react";
import { BodyPartPinType, MedicalItemType } from "./BodyPartsStats";
import BodyModel from "./BodyModel";
import plusImage from "../assets/images/Frame 68.png";
import Text from "../../../components/ui/Text";
import MedicalItems from "./MedicalItems";

type RightPanelProps = {
  medicalItems: MedicalItemType[];
  className?: string;
  title?: string;
  description?: string;
  onButtonClick?: () => void;
  bodyPartsPins: BodyPartPinType[];
};

const RightPanel: React.FC<RightPanelProps> = ({
  medicalItems,
  className = "",
  title = "Starea Actuala",
  description = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod",
  onButtonClick,
  bodyPartsPins,
}) => {
  return (
    <div
      className={`pt-7 pr-14 pb-7 flex flex-col justify-between items-end space-y-10 ${className}`}
    >
      {/* Title */}
      <div className="flex items-center space-x-2 mr-[-40px]">
        <div className="relative mr-[-25px]">
          <Text
            size="3xl"
            className="text-white !font-semibold purista-font uppercase leading-[1]"
          >
            {title}
          </Text>
          <Text
            size="xs"
            className="text-white/50 text-right gilroy-font max-w-[380px] ml-auto leading-[1]"
          >
            {description}
          </Text>
        </div>

        <button
          onClick={() => {
            if (onButtonClick) onButtonClick();
          }}
          title="Click me"
          className="w-[125px] h-[125px] transition hover:opacity-80 active:scale-95 mt-[-20px]"
        >
          <img src={plusImage} className="w-full h-full object-contain" />
        </button>
      </div>

      {/* Silhouette Placeholder */}
      <BodyModel bodyPartsPins={bodyPartsPins} />

      {/* Medical Items */}
      <MedicalItems medicalItems={medicalItems} />
    </div>
  );
};

export default RightPanel;
